module.exports = __webpack_public_path__ + "img/cadre-sante-h.83ebd02f.jpg";